import BaseCRUDMethods from '~/api/methods/base';

export default class ShipmentMethods extends BaseCRUDMethods {
  constructor () {
    super({ route: 'shipment' });
  }

  getOne (id) {
    return this.sender.get(`${this.route}/${id}`);
  }

  create (req, opts = {}) {
    return this.sender.post(this.route, req.buildBooking(opts));
  }

  createPost (req, opts) {
    return this.sender.post(`${this.route}/post`, req.buildPostBooking(opts));
  }

  createCorrespondence (req, opts) {
    return this.sender.post(`${this.route}/correspondence`, req.buildCorrespondenceBooking(opts));
  }

  book (id, req) {
    return this.sender.patch(`${this.route}/${id}/book`, req.buildEdit());
  }

  editAwb (id, req) {
    return this.sender.patch(`${this.route}/${id}/awb`, req.build());
  }

  accept (id) {
    return this.sender.patch(`${this.route}/${id}/accept`);
  }

  unaccept (id) {
    return this.sender.patch(`${this.route}/${id}/unaccept`);
  }

  savePdf (id, data) {
    const request = { ...data };
    if (data.type === 'default') delete request.type;
    return this.sender.get(`${this.route}/${id}/awbPdf`, request, { responseType: 'blob' });
  }

  saveLetterPdf (id) {
    return this.sender.get(`${this.route}/order/id-${id}/letter`, {}, { responseType: 'blob' });
  }

  getAwbPreviewHtml (id, req) {
    const { type, ...request } = req;
    return this.sender.get(`${this.route}/${id}/awbHtml`, request);
  }

  getLetterPreviewHtml (id) {
    return this.sender.get(`${this.route}/order/id-${id}/letterHtml`);
  }

  getBarcodedLabel (awb) {
    return this.sender.get(`${this.route}/${awb}/barcoded-label`, {}, { responseType: 'blob' });
  }

  getParticipantsLabel (awb) {
    return this.sender.get(`${this.route}/${awb}/participants-label`, {}, { responseType: 'blob' });
  }

  getFFA (id) {
    return this.sender.get(`${this.route}/${id}/ffa`);
  }

  sendFFA (id, req) {
    return this.sender.post(`${this.route}/${id}/ffa`, req.build());
  }

  getAttachments (mawb) {
    return this.sender.get(`${this.route}/${mawb}/file`);
  }

  addAttachment (mawb, req) {
    // eslint-disable-next-line vue/max-len
    return this.sender.post(`${this.route}/${mawb}/file`, req.build(), null, { headers: { 'Content-Type': 'multipart/form-data' } });
  }

  downloadAttachment (id) {
    return this.sender.get(`${this.route}/file/download`, { id }, { responseType: 'blob' });
  }

  removeAttachment (mawb, id) {
    return this.sender.delete(`${this.route}/${mawb}/file/id-${id}`);
  }

  cancelBooking (mawb) {
    return this.sender.post(`${this.route}/${mawb}/remove`, {});
  }

  editBookings (req) {
    return this.sender.patch(`${this.route}/edit/booking-cargo`, req.build());
  }

  getFopList (mawb) {
    return this.sender.get(`${this.route}/${mawb}/available-fop`);
  }

  refund (mawb, data) {
    // eslint-disable-next-line vue/max-len
    return this.sender.post(`${this.route}/${mawb}/refund`, data, { headers: { 'Content-Type': 'multipart/form-data' } });
  }

  refundPricing (mawb) {
    return this.sender.get(`${this.route}/${mawb}/refund-pricing`);
  }

  getFareRules (mawb) {
    return this.sender.get(`fare-rules/shipment/${mawb}`);
  }

  changeRefundBidStatus (id, status) {
    return this.sender.patch(`${this.route}/refund-bid/id-${id}/status`, { status });
  }

  cancelRefund (id) {
    return this.sender.delete(`${this.route}/refund-bid/id-${id}`);
  }

  downloadRefundBidAttachment (id) {
    // eslint-disable-next-line vue/max-len
    return this.sender.get(`${this.route}/refund-bid/attachment/id-${id}`, {}, { responseType: 'blob' });
  }

  reprice (mawb) {
    return this.sender.patch(`${this.route}/${mawb}/repricing`);
  }

  getHistory (mawb, req) {
    return this.sender.get(`${this.route}/${mawb}/audit`, req.build());
  }
}
